<template>
    <div
        class="badge"
        :class="badgeClass"
        data-test="badge-label"
    >
        {{ titleCase(value) }}
    </div>
</template>

<script>
    import { titleCase } from 'change-case'

    export default {
        name: 'Badge',
        props: {
            value: {
                type: String,
                default: ''
            }
        },
        computed: {
          badgeClass() {
              switch (this.value.toLowerCase()) {
                  case 'new':
                      return 'badge--info'
                  default:
                      return ''
              }
          }
        },
        methods: {
            titleCase
        }
    }
</script>
<style lang="css" scoped src="../../node_modules/@servicensw/buttons/dist/buttons.css"></style>
<style scoped lang="scss">
    .badge {
        line-height: 1.6;
        font-size: 10px;
        text-transform: none;
        color: #fff;
        background-color: var(--shuttle-grey);
        border-color: var(--shuttle-grey);
    }

    .badge--info {
        color: #fff;
        background-color: var(--info-blue);
    }
</style>
